import { Controller } from "@hotwired/stimulus"

/**
 * Envía el formulario como visita Turbo al frame indicado en data-turbo-frame.
 * Necesario porque en application.js está Turbo.config.forms.mode = "off", con lo que
 * requestSubmit() provoca navegación completa del navegador.
 */
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 400 }
  }

  scheduleSubmit() {
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(() => this.visitFrame(), this.delayValue)
  }

  interceptSubmit(event) {
    const form = this.element
    const turbo = globalThis.Turbo
    if (form.dataset.turboFrame && turbo?.visit) {
      event.preventDefault()
      this.visitFrame()
    }
  }

  visitFrame() {
    const form = this.element
    const frameId = form.dataset.turboFrame
    const turbo = globalThis.Turbo

    if (!frameId || !turbo?.visit) {
      form.requestSubmit()
      return
    }

    const url = new URL(form.action || window.location.href, window.location.origin)
    const data = new FormData(form)
    data.forEach((value, key) => {
      url.searchParams.append(key, value)
    })

    turbo.visit(url.toString(), { frame: frameId, action: "replace" })
  }

  disconnect() {
    clearTimeout(this.timeoutId)
  }
}
